// extracted by mini-css-extract-plugin
export default {"iconContainer":"ApprovalIcon_iconContainer__P433A","icon":"ApprovalIcon_icon__NDckw"};